module.exports = __webpack_public_path__ + "media/images/icons/filled/play-square-63894c0465771940dfa3cebb2a467134.svg";